require('jquery-mask-plugin');

class MaskController {
    constructor($attrs, $element) {
        $attrs.$observe('wowMask', val => $element.mask(val));
    }
}

module.exports = () => ({
    restrict: 'A',
    scope: false,
    controller: ['$attrs', '$element', MaskController],
});



// WEBPACK FOOTER //
// ./src/olycommon/mask/mask.directive.js